import { queryOptions, useQuery } from '@tanstack/react-query';

import { type ClassDetails } from '~entities/classes/modal/class';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetClassParams {
  classId: string | number;
}

export const getActiveClassAPI = async (params: GetClassParams) => {
  const response = await baseAPI.get<ClassDetails>(
    `/enrollments/${params.classId}/active`,
  );
  return response.data;
};

export const getActiveClassQueryOptions = (classId: string | number) =>
  queryOptions({
    queryKey: [KEYS.CLASSES, classId],
    queryFn: () => getActiveClassAPI({ classId }),
    experimental_prefetchInRender: true,
    staleTime: 1000 * 60 * 5,
  });

export const useGetActiveClass = (params: GetClassParams) => {
  return useQuery(getActiveClassQueryOptions(params.classId));
};
